module.exports = __webpack_public_path__ + "media/images/voice10-2-97fa5dc1ca55d161395eb8c4868d1e35.jpg";